import React, { Component } from 'react';

export default class Topbar extends Component {

    componentDidMount() {
        localStorage.setItem('LANG', 'EN');
    }

    handleChangeClanguage = (language) => (e) => {
        e.preventDefault();
        localStorage.setItem('LANG', language);
        document.location.reload();
    }

    render() {
        return (
            <div className="row top-bar">
                <div className="container">
                    <div className="col-md-6  hidden-sm hidden-xs">
                        <div className="row tel-top">
                            <div className="col-md-2">
                                LANGUAGE:
                            </div>
                            <div className="col-md-6">
                                <a
                                    style={{marginRight: 5}}
                                    href=""
                                    onClick={this.handleChangeClanguage('CN')}>
                                        <span className="flag-icon flag-icon-cn" style={{fontSize: 20}}></span>
                                    </a>
                                <a
                                    href=""
                                    onClick={this.handleChangeClanguage('EN')}>
                                    <span className="flag-icon flag-icon-us" style={{fontSize: 20}}></span>
                                </a>
                            </div>
                            {/*<div className="col-md-4">Toll Free:<b>(888) 620-4623</b></div> */}
                            {/*<div className="col-md-4">PH:<b>(949) 459-6871</b></div> */}
                        </div>
                    </div>
                    <div className="small-logo col-md-12 visible-sm visible-xs">
                        <div className="logo-small"></div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/partials/TopBar.js